import { Component, Inject, Prop, Vue } from 'vue-property-decorator'
import { Validator } from 'vee-validate'
import { ConfigurationIntermediateShelfSampleProcessAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-intermediate-shelf-sample-process-assignment/configuration-intermediate-shelf-sample-process-assignment.dto'
import { ConfigurationSampleProcessResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-sample-process/configuration-sample-process.dto'
import { configurationSampleProcessService } from '@/modules/configurationModule/detail/automation/grossing-shelf/intermediate-shelf-process/services/configuration-sample-process/configuration-sample-process.service'
import { CommonParams } from '@/api/resources/common/shared/models/common.models'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

@Component
export default class ConfigurationAutomationGrossingShelfIntermediateShelfProcessModalBasicForm extends Vue {
    @Prop(String) readonly actionTitle!: string
    @Prop() readonly intermediateShelfSampleProcessAssignment!: Partial<ConfigurationIntermediateShelfSampleProcessAssignmentResponse>

    @Inject() externalValidator!: Validator

    get updateMode(): boolean {
        return !!this.intermediateShelfSampleProcessAssignment?.id
    }

    async getSampleProcesses(): Promise<ConfigurationSampleProcessResponse[]> {
        const params: CommonParams = {
            size: PAGINATOR_BIG_PAGE_SIZE
        }
        const response = await this.$_toCallUnique(configurationSampleProcessService.paginator(undefined, params))
        if (response) {
            return response.content
        }
        return []
    }

    constructor() {
        super()

        this.$validator = this.externalValidator
    }
}
